/**
 * Asynchronously loads the component for Login
 */

import { lazyLoad } from "utils/loadable";

export const CompanyRegistration = lazyLoad(
  () => import("./index"),
  (module) => module.CompanyRegistration
);
